import { useQuery } from '@tanstack/react-query';

import { getInquiryV2QueryOptions } from '@/services/getInquiryV2';
import { getLinkedSourceConversationId } from '@/util/inquiryGroups';

/**
 * The conversation a "Linked from" banner should open for an inquiry that references a source
 * conversation. Loads the referenced inquiry, which the banner reads anyway, to find the source
 * thread addressed to the same expert as this one. Until it loads, or when none matches, it is
 * the reference itself, so the link always has somewhere to go.
 */
export function useLinkedSourceConversationId({
  referenceConversationId,
  recipientId,
}: {
  referenceConversationId?: string;
  recipientId?: number | string | null;
}) {
  const { data: referencedInquiry } = useQuery({
    ...getInquiryV2QueryOptions({ conversationId: referenceConversationId as string }),
    enabled: !!referenceConversationId,
  });

  if (!referenceConversationId) {
    return undefined;
  }

  return getLinkedSourceConversationId({
    referenceConversationId,
    referencedGroupInquiries: referencedInquiry?.groupInquiries,
    recipientId,
  });
}
